import React, { useState, useEffect } from 'react';
import { statsService } from '../api/services';
import './RankingsPage.css';

// 排行榜分頁定義：對應後端回傳的資料鍵與各自的數值欄位。
// 後端已修正先前笛卡兒積導致的數字膨脹，並提供以貢獻分數為核心的多維度榜單。
const TABS = [
  { key: 'topContributors', label: '綜合貢獻', valueKey: 'contributionScore', valueLabel: '貢獻分' },
  { key: 'topAccepted', label: '最佳解答', valueKey: 'acceptedCount', valueLabel: '最佳解答數' },
  { key: 'topVoted', label: '最受認同', valueKey: 'votesReceived', valueLabel: '獲讚數' },
  { key: 'topPosters', label: '發文王', valueKey: 'postCount', valueLabel: '發文數' },
];

const RankingsPage = () => {
  const [rankings, setRankings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('topContributors');

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        const res = await statsService.getRankings();
        setRankings(res.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchRankings();
  }, []);

  if (loading) return <div className="container mt-5">載入中...</div>;

  const currentTab = TABS.find((t) => t.key === activeTab);
  const data = rankings?.[activeTab] || [];

  return (
    <div className="rankings-page">
      <div className="container">
        <div className="page-header">
          <h1>活躍度排行榜</h1>
          <p>以貢獻為核心：發文、解答、獲得的認同共同累積你的影響力</p>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="ranking-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              className={`ranking-tab ${activeTab === t.key ? 'active' : ''}`}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="ranking-content">
          {data.length === 0 ? (
            <div className="ranking-empty">目前還沒有足夠的資料</div>
          ) : (
            <table className="ranking-table">
              <thead>
                <tr>
                  <th>排名</th>
                  <th>使用者</th>
                  <th>{currentTab.valueLabel}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((u, index) => (
                  <tr key={u.id} className={index < 3 ? `top-${index + 1}` : ''}>
                    <td className="rank">
                      {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `#${index + 1}`}
                    </td>
                    <td className="user-name">{u.display_name || u.name}</td>
                    <td className="value">{u[currentTab.valueKey]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default RankingsPage;
